<template>
  <li class="mega-menu__menu-item mega-menu__menu-item--depth-3" v-if="itemIsDefined(itemDepth2, 'title')">
    <a
      :href="getLink(itemDepth2)"
      class="mega-menu__link mega-menu__link--depth-3"
      >{{ itemDepth2.title }}</a
    >
  </li>
</template>

<script>
import mainSite from "@/util/mainSite"

export default {
  name: "mobile-menu-level-3",
  mixins: [mainSite],
  props: {
    itemDepth2: {
      type: Object,
      required: true,
    },
  },
};
</script>